import React, { ReactElement } from 'react';
import styled, { css } from 'styled-components';

import Button from '~/components/atom/Button';
import TEST_ID from './index.testid';
import Catalog from '~/Catalog';
import JustificationContainer from '~/components/atom/JustificationContainer';
const text = {
  errorMessage:
    'Er is iets fout gegaan bij het opvragen van de gegevens. Probeer het later nog eens.',
};

type Props = {
  message?: string;

  /** Render it inline (so no padding and take over the font) */
  inline?: boolean;

  /** Default: true */
  setBackgroundColor?: boolean;

  /** If given, a try again button will be displayed and the onClick function will be called if the user clicks it */
  tryAgain?: {
    buttonLabel: string;
    onClick: () => void;
  };
  errorType?: string;
};

const AppErrorScreen: React.FCC<Props> = ({
  message,
  inline,
  setBackgroundColor = true,
  errorType,
  tryAgain,
  ...rest
}) => {
  let buttonComponent: ReactElement | null = null;

  if (tryAgain) {
    buttonComponent = (
      <StyledButton
        size="medium"
        onClick={tryAgain.onClick}
        label={tryAgain.buttonLabel}
      />
    );
  }

  return (
    <Container
      direction="column"
      align="center"
      justification="center"
      data-testid={TEST_ID.CONTAINER}
      {...rest}
      data-error={errorType}
      $setBackgroundColor={setBackgroundColor}
    >
      <Text $inline={inline}>{message || text.errorMessage}</Text>
      {buttonComponent}
    </Container>
  );
};

type ContainerProps = {
  $setBackgroundColor: boolean;
};
const Container = styled(JustificationContainer)<ContainerProps>(
  ({ theme, $setBackgroundColor }) => css`
    text-align: center;
    /* TODO: Check if it is okay to set height to 100% */
    height: 100%;
    border-radius: ${theme.getTokens().border.radius.base};
    color: ${theme.color('text', 'light')};

    ${$setBackgroundColor &&
    css`
      background-color: ${theme.color('white', 'dark')};
    `};
  `,
);

type TextProps = {
  $inline?: boolean;
};
const Text = styled.p<TextProps>`
  ${({ $inline }) => {
    if (!$inline) {
      return `
        font-size: 1.5em;
        margin: 2em;
      `;
    }

    return ``;
  }}
`;

const StyledButton = styled(Button)<{}>`
  ${({ theme }) => `
    margin: ${theme.space('xl')} auto ${theme.space('base')} auto;
  `}
`;

export const UnauthorizedAppErrorScreen = (props: Props) => (
  <AppErrorScreen message={Catalog.unauthorisedErrorMessage} {...props} />
);

export default AppErrorScreen;
